import styled, { css } from 'styled-components';

import { LeftQuoteIcon, RightQuoteIcon } from 'Components/QuoteBlock/QuoteBlock.styled';

export const Tabs = styled.div`
    ${({ theme }) => css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        column-gap: 0.5rem;

        @media ${theme.breakpoints.medium.media} {
            justify-content: space-between;
        }
    `}
`;

export const Label = styled.span<{ $isActive: boolean }>`
    ${({ theme, $isActive }) => css`
        position: relative;
        display: inline-block;
        font-size: 1rem;
        opacity: 1;
        z-index: 2;
        color: ${theme.colors.primaryContrast.hex};

        @media ${theme.breakpoints.smallLarge.media} {
            color: ${$isActive ? '#595959' : theme.colors.primaryContrast.hex};
        }

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.5rem;
        }
    `}
`;

export const Tab = styled.button<{ $isActive: boolean }>`
    ${({ $isActive, theme }) => css`
        position: relative;
        flex-grow: 1;

        cursor: pointer;
        line-height: 1.2;
        padding: 1rem 0.25rem;
        width: 32%;
        background-color: ${!$isActive
            ? `rgb(${theme.colors.tertiary.rgb}, 0.7)`
            : `rgb(${theme.colors.tertiary.rgb}, 0.9)`};
        border: none;
        transform: translateZ(0);
        border-radius: 0.5rem;
        outline: ${$isActive ? `0.2rem solid ${theme.colors.primaryContrast.hex}` : 'none'};

        :not(:last-of-type) {
            margin-bottom: 0.5rem;
        }

        :last-of-type {
            width: 100%;
        }

        :hover {
            transform: translateZ(0);
            background-color: rgb(${theme.colors.tertiary.rgb}, 0.9);
        }

        @media ${theme.breakpoints.smallLarge.media} {
            padding: 1rem 1.75rem;
            border-radius: ${$isActive ? '0.5rem 0.5rem 0 0' : '0.5rem'};
            outline: unset;

            :last-of-type {
                width: 32%;
            }

            :hover {
                transform: translateZ(0);
                outline: ${!$isActive
                    ? `0.2rem solid ${theme.colors.primaryContrast.hex}`
                    : 'none'};
                background-color: rgb(${theme.colors.tertiary.rgb}, 0.9);
            }
            :not(:last-of-type) {
                margin-bottom: unset;
            }

            ${$isActive &&
            css`
                &:after {
                    content: '';
                    position: absolute;
                    width: 100%;
                    bottom: -2rem;
                    left: 0;
                    right: 0;
                    top: 0;
                    transform: translateZ(0);
                    border-radius: 0.5rem 0.5rem 0 0;
                    background: ${theme.colors.primaryContrast.hex};
                }
            `}
        }
    `}
`;

export const PanelContainer = styled.div`
    ${({ theme }) => css`
        border-radius: 0.5rem;
        transform: translateZ(0);
        background: ${theme.colors.primaryContrast.hex};
        margin-top: 1.5rem;
        padding: 1rem;

        @media ${theme.breakpoints.large.media} {
            padding: 1rem 7rem;
        }

        h2,
        h3 {
            font-family: ${theme.fonts.secondary};
            font-weight: 300;

            @media ${theme.breakpoints.large.media} {
                font-size: 3.5rem;
                line-height: 1;
            }
        }

        ${LeftQuoteIcon} {
            opacity: 0.9;
        }

        ${RightQuoteIcon} {
            opacity: 0.9;
        }
    `}
`;

export const Panel = styled.div`
    padding-top: 1.5rem;
`;
